const ONE_MINUTE = 60_000;
const ONE_HOUR = 60 * ONE_MINUTE;
export const CACHE_TIMES = {
    ZERO: 0,
    FIVE_SECONDS: 5000,
    ONE_MINUTE: ONE_MINUTE,
    FIVE_MINUTES: 5 * ONE_MINUTE,
    TWO_MINUTES: 2 * ONE_MINUTE,
    TEN_MINUTES: 10 * ONE_MINUTE,
    FIFTEEN_MINUTES: 15 * ONE_MINUTE,
    THIRTY_MINUTES: 30 * ONE_MINUTE,
    ONE_HOUR: ONE_HOUR,
    TWELVE_HOURS: 12 * ONE_HOUR,
    DAY: 24 * ONE_HOUR,
    WEEK: 7 * 24 * ONE_HOUR,
    THIRTY_DAYS: 30 * 24 * ONE_HOUR,
    NO_EXPIRATION: Number.POSITIVE_INFINITY,
};
export const PERSIST_META = {
    persist: true,
};
export function modifyExistingQueryData(queryClient, queryKey, updater) {
    return queryClient.setQueryData(queryKey, (old) => {
        if (!old)
            return old;
        return updater(old);
    });
}
export function setQueriesData(queryClient, queryKey, updater) {
    return queryClient.setQueriesData({
        queryKey,
    }, (old) => {
        if (!old)
            return old;
        return updater(old);
    });
}
//# sourceMappingURL=query.js.map